export const LEVELS = [
  { rank: 1, name: 'NOVICE', description: 'Beginner, requires supervision' },
  { rank: 2, name: 'INTERMEDIATE', description: 'Can perform with some guidance' },
  { rank: 3, name: 'PROFICIENT', description: 'Independent, solid contributor' },
  { rank: 4, name: 'ADVANCED', description: 'Expert in most scenarios' },
  { rank: 5, name: 'EXPERT', description: 'Authority, mentor, innovator' },
];
